import 'utils/polyfills'
import 'Security/AccessMode'
import 'Util.js'

/**
 * @const {string}
 */
global.GLONASS_PROJ = 'EPSG:4326';
/**
 * @const {string}
 */
global.DISPLAY_PROJ = "EPSG:4326";
/**
 * @const {string}
 */
global.MAP_PROJ = "EPSG:3857";

// Postgresql
global.pgIntArrayDecode = function(string) {
    if (Util.isArray(string)) {
        return string;
    }

    if (!string || typeof(string) != "string") {
        return [];
    }

    string = string.replace(/[{}]/g, "");

    var array = string.length ? string.split(",") : [];

    for (var i = 0, count = array.length; i < count; i++) {
        array[i] = +array[i];

        if (isNaN(array[i])) {
            array[i] = 0;
        }
    }

    return array;
};

global.pgIntArrayEncode = function(array) {
    if (typeof(array) == "string") {
        return array;
    }

    if (!array || !Util.isArray(array)) {
        return "{}";
    }

    for (var i = 0, count = array.length; i < count; i++) {
        array[i] = +array[i];

        if (isNaN(array[i])) {
            array[i] = 0;
        }
    }

    return "{" + array.join(",") + "}";
};

global.pgArrayDecode = function(string) {
    if (Util.isArray(string)) {
        return string;
    }

    if (!string || typeof(string) != "string") {
        return [];
    }

    var array = [];
    var regexp = /[\{,]("(?:\\"|\\\\|[^"])*"|[^,"\\}]*)\}?/g;
    var match;

    while (match = regexp.exec(string)) {
        var item = match[1];

        if (item.length && item[0] == '"') {
            item = item.slice(1, -1);
        }

        item = item.replace(/\\\\/g, '\\').replace(/\\"/g, '"');

        array.push(item);
    }

    return array;
};

global.pgArrayEncode = function(array) {
    if (typeof(array) == "string") {
        return array;
    }

    if (!array || !Util.isArray(array)) {
        return "{}";
    }

    for (var i = 0, count = array.length; i < count; i++) {
        var item = array[i];

        item = '"' + item.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
        array[i] = item;
    }

    return "{" + array.join(",") + "}";
};

/**
 * @param {string} key
 * @param {number|Array.<Number>} [mode=Security.AccessMode.Execute]
 * @returns {boolean}
 */
global.check = function(key, mode) {
    return application.security.check(key, mode);
};

/**
 * @param {string} key
 * @param {number|number[]} mode
 * @returns {boolean}
 * @throws AccessDeniedError
 */
global.verify = function(key, mode) {
    const title = _.isArray(mode) ?
                  _.map(mode, Security.AccessMode.title.bind(Security.AccessMode)).join(", ") :
                  Security.AccessMode.title(mode);

    assert(check(key, mode), `Доступ запрещен ${key} (${title})`, AccessDeniedError);

    return true;
};

global.checkNotify = function(key, mode) {
    try {
        return verify(key, mode);
    } catch (e) {
        alert(e.message);
        return false;
    }
};

global.isRoot = function() {
    return application.security.isRoot();
};

global.appSettings = function(settings) {
    settings = Util.object(settings);

    if (typeof(settings.xhr) == "object") {
        if (settings.xhr.prefix !== undefined) {
            Xhr.prefix = settings.xhr.prefix;
        }

        if (settings.xhr.header) {
            Xhr.appendAjaxPrefilter();
        }
    }

    if (typeof(settings.module) == "object") {
        if (settings.prefix != undefined) {
            Module.prefix = settings.prefix;
        }
    }
};

global.coalesce = function() {
    for (var i = 0, count = arguments.length; i < count; i++) {
        if (arguments[i] !== undefined && arguments[i] !== null) {
            return arguments[i];
        }
    }

    return null;
};

global.async = function(callback, options, steps, timeout, finished) {
    timeout = coalesce(timeout, 1);
    steps = coalesce(steps, 5);

    callback(options);

    steps--;

    if (steps) {
        setTimeout(function() {
            async(callback, options, steps, timeout, finished);
        }, timeout);
    } else {
        if (finished) {
            finished();
        }
    }
};

global.context = function(value) {
    try {
        var context = application.security.context;

        if (value) {
            return Util.Object.value(context, value);
        }

        return context;
    } catch (e) {
        console.log(e);
        return null;
    }
};

/**
 * Asserts some expression is true
 * @param condition
 * @param message
 * @param error
 */
global.assert = function(condition, message = '', error = Error) {
    message = 'Assertion failed' + ( message ? ': ' + message : '' );

    if (!condition) {
        throw new error(message);
    }
};

/**
 * used for passing callback that do nothing
 */
global.noop = function() {};

/**
 * Used in lodash `merge` function as customizer to merge only plain objects
 *  and copy other objects
 *
 * @param objValue
 * @param srcValue
 * @returns {*}
 */
global.mergePlainOnlyCustomizer = function(objValue, srcValue) {
    if (_.isObject(srcValue) && !_.isPlainObject(srcValue)) {
        return srcValue;
    }
};

/**
 * @param {*} value
 * @returns {boolean}
 */
global.isTemplate = value => _.isString(value) && (
    ~value.search(_.templateSettings.interpolate) || ~value.search(_.templateSettings.evaluate)
);

global.isGenerator = function (arg) {
    return typeof arg === 'object' && typeof arg.next === 'function' && typeof arg.throw === 'function'
}

global.isPromise = function (arg) {
    return typeof arg === 'object' && typeof arg.then === 'function' && typeof arg.catch === 'function'
}

global.webglSupport = function () {
    try {
        let canvas = document.createElement('canvas')
        return !!window.WebGLRenderingContext && (
            canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
        )
    } catch (e) { return false }
}
